import React from 'react';
import css from './css.module.less';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { Button, Form, Checkbox } from '@/src/components/Antd';
import EditDraggableTable from '@/src/components/DroppableTable/EditDraggableTable';
import { genderColumns } from './config';
import ModalHoc from 'src/constrains/ModalHOC';
import EditModal from './EditModal';

const List = Form.List;
const kF = 'script';
const kE = 'enableJavascript';
const kL = 'scriptList';
export { kF, kL };
const Script = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { form, disabled, modalOp, onValuesChange } = props;
  const { setShowModal, setModalTitle, setModalContent } = modalOp;

  const handleOnAddScript = (_, add) => {
    setModalTitle(getI18n('salesChannelDigitalMarketing.index.addScript'));
    setModalContent(
      <EditModal
        onCancel={() => {
          setShowModal(false);
        }}
        data={{ uuid: null }}
        onConfirm={(data) => {
          //form.setFieldsValue
          // const oL = form.getFieldValue([kF, kL]) || [];
          //[kF, kL], [...oL, data]
          //form.setFieldsValue({ [kF]: { [kL]: [...oL, data] } });
          add(data);
          setShowModal(false);
        }}
      />,
    );
    setShowModal(true);
  };
  const handleOnEditScript = (index) => {
    const d = form.getFieldValue([kF, kL, index]);

    setModalTitle(getI18n('salesChannelDigitalMarketing.index.editScript'));
    setModalContent(
      <EditModal
        onCancel={() => {
          setShowModal(false);
        }}
        data={d}
        onConfirm={(data) => {
          const oL = form.getFieldValue([kF, kL]) || [];
          oL.splice(index, 1, data);
          form.setFieldsValue({ [kF]: { [kL]: oL } });
          setShowModal(false);
          if (onValuesChange) onValuesChange();
        }}
      />,
    );
    setShowModal(true);
  };
  const handleOnOrderChange = (e, value, move) => {
    const { from, to } = value;
    move(from, to);
  };
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      className={css.wrapper}
      title={'JavaScript'}
      subtitle={getI18n('salesChannelDigitalMarketing.index.subtitle')}>
      <div className={css.content}>
        <Form.Item name={[kF, kE]} valuePropName='checked'>
          <Checkbox
          // onChange={(e) => {
          //   setEnableGoogleAnalytics(e.target.checked);
          // }}
          //disabled={!edit_digital_marketing_settings}
          >
            <span>{getI18n('general.enabled')} JavaScript</span>
          </Checkbox>
        </Form.Item>
        <Form.Item
          shouldUpdate={(p, c) => {
            const pV = get(p, [kF, kE]);
            const cV = get(c, [kF, kE]);
            return pV !== cV;
          }}>
          {({ getFieldValue }) => {
            const v = get(getFieldValue(kF), kE);
            return v ? (
              <div className={css.list}>
                <List name={[kF, kL]}>
                  {(fields, { add, move, remove }) => {
                    return (
                      <React.Fragment>
                        <EditDraggableTable
                          hideAllDragHandlers={disabled}
                          id='Script'
                          dataSource={fields}
                          columns={genderColumns(
                            remove,

                            disabled,
                            handleOnEditScript,
                            {
                              getI18n,
                            },
                          )}
                          rowKey={(value) => {
                            return get(value, 'fieldKey');
                          }}
                          pagination={false}
                          onTableChange={(e, value) => {
                            handleOnOrderChange(e, value, move);
                          }}
                        />
                        <div className={css.addBtn}>
                          <Button
                            type='primary'
                            onClick={() => handleOnAddScript(fields, add)}
                            disabled={disabled}>
                            {getI18n(
                              'salesChannelDigitalMarketing.index.addScript',
                            )}
                          </Button>
                        </div>
                      </React.Fragment>
                    );
                  }}
                </List>
              </div>
            ) : null;
          }}
        </Form.Item>
      </div>
      {/* <List name={[kF, kL]}> {(fields, { add, remove }, errors) => {}}</List> */}
    </SectionWrapper>
  );
};
export default ModalHoc(Script);
